import {PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer} from 'recharts'
import {useTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useMemo} from 'react'
import {PieChartLegend, PieChartLegendData} from '../pie-chart-legend/PieChartLegend'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {useTranslation} from '@/translations/i18n'

export const DashboardTherapistRehabilitationPieChart = () => {
    const {palette} = useTheme()
    const {t} = useTranslation()

    const {data} = useGetDashboardConsultants({
        fields: ['operativeConsultants']
    })

    const chartData = useMemo(() => {
        return [
            {
                name: t('dashboard:therapist_domiciliary'),
                value: data?.operativeConsultants?.therapists.domiciliary,
                color: palette.purple[200]
            },
            {
                name: t('dashboard:therapist_outpatient'),
                value: data?.operativeConsultants?.therapists.outpatient,
                color: palette.purple[400]
            },
            {
                name: t('dashboard:therapist_outpatient_domiciliary'),
                value: data?.operativeConsultants?.therapists.outpatient_domiciliary,
                color: palette.purple[800]
            }
        ]
    }, [data?.operativeConsultants?.therapists])

    const legendData: PieChartLegendData[] = [
        {name: t('dashboard:therapist_domiciliary'), color: palette.purple[200]},
        {name: t('dashboard:therapist_outpatient'), color: palette.purple[400]},
        {name: t('dashboard:therapist_outpatient_domiciliary'), color: palette.purple[800]}
    ]

    return (
        <Flexbox align="center" gap={6}>
            <ResponsiveContainer width={120} height={120}>
                <RechartsPieChart>
                    <Pie data={chartData} cx="50%" cy="50%" outerRadius={60} dataKey="value">
                        {chartData.map((entry, index) => (
                            <Cell key={index} fill={entry.color} />
                        ))}
                    </Pie>
                </RechartsPieChart>
            </ResponsiveContainer>
            <PieChartLegend data={legendData} />
        </Flexbox>
    )
}
